import {Component, OnDestroy, OnInit} from '@angular/core';

import { AuthenticationService, KeepAliveService } from './core/services';
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

  constructor(
    private keepAlive: KeepAliveService,
    private authenticationService: AuthenticationService,
    private translate: TranslateService) {
    this.translate.setDefaultLang('da');
    this.translate.use('da');
    this.keepAlive.interval(30);
    this.keepAlive.setCallback(() => {
      if (!this.authenticationService.hasSignedIn()) return;

      this.authenticationService.refreshToken().subscribe(success => {
        if (success) return;

        this.authenticationService.signOut().subscribe(() => location.reload());
      });
    });
    this.keepAlive.start();
  }

  ngOnInit() {
    document.body.classList.add('light-theme');
  }

  ngOnDestroy() {
    this.keepAlive.stop();
  }
}
